import * as Yup from 'yup';
import { StepNewOperatorForm } from './step-new-operator-types';

export const stepNewOperatorSchema = () =>
  Yup.object<StepNewOperatorForm>().shape({
    newOperator: Yup.mixed().nullable().required('Povinné pole'),
  });
